/* Vue admin — contenus de toute la plateforme (bloc 10c, miroir plateforme de */
/* la vue direction). Lecture seule : aucune action d'écriture depuis cet écran. */

import { api } from './api';

export type AdminContentDocumentKind = 'general' | 'course' | 'exercice_sheet' | 'exam';

export interface AdminContentDocument {
  id: string;
  teacher_id: string;
  teacher_name: string;
  school_id: string;
  school_name: string;
  kind: AdminContentDocumentKind;
  title: string;
  level_id: string;
  subject_id: string;
  folder_id: string | null;
  global_correction_rules: string | null;
  archived_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface AdminContentDocumentsPage {
  items: AdminContentDocument[];
  total: number;
}

export interface AdminContentDocumentSection {
  id: string;
  document_id: string;
  position: number;
  type: string;
  title: string | null;
  content: unknown;
  created_at: string;
  updated_at: string;
}

export interface AdminContentDocumentDetail extends AdminContentDocument {
  sections: AdminContentDocumentSection[];
}

export interface ListAdminContentDocumentsFilters {
  page?: number;
  limit?: number;
  schoolId?: string;
  teacherId?: string;
  kind?: AdminContentDocumentKind;
  levelId?: string;
  subjectId?: string;
  search?: string;
  includeArchived?: boolean;
}

export interface AdminContentTeacherOption {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string | null;
}

export async function listAdminContentDocuments(
  filters: ListAdminContentDocumentsFilters = {},
): Promise<AdminContentDocumentsPage> {
  return (await api.admin.content.list.query(filters)) as AdminContentDocumentsPage;
}

export async function getAdminContentDocument(id: string): Promise<AdminContentDocumentDetail | null> {
  return (await api.admin.content.get.query({ id })) as AdminContentDocumentDetail | null;
}

export async function listAdminContentTeachers(schoolId: string): Promise<AdminContentTeacherOption[]> {
  return (await api.admin.content.teachersForSchool.query({ schoolId })) as AdminContentTeacherOption[];
}
